<template>
    <label
        class="ui-input-toggle"
        :class="[{ 'is-active': isChecked }]"
        :for="id"
    >
        <span class="ui-input-toggle__label">
            <template v-if="label">
                {{ label }}
            </template>
            <template v-else>
                <slot />
            </template>
        </span>
        <input :id="id" v-model="isChecked" :value="value" type="checkbox" />
        <span class="ui-input-toggle__switch"> </span>
    </label>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [Object, Array, String, Number, Boolean],
            default: false
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isChecked: {
            get: function () {
                return this.checked
            },
            set: function (value) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        value(newVal) {
            this.isChecked = newVal
        }
    }
}
</script>

<style scoped lang="scss">
.ui-input-toggle {
    $b: &;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.is-active {
        #{$b}__label {
            color: $text-color;
        }

        #{$b}__switch {
            border: 1px solid $sherpa-blue-light;
            background-color: $sherpa-blue-light;

            &::after {
                transform: translateX(15px);
                background-color: $sherpa-blue;
            }
        }
    }

    input {
        width: 100%;
        height: 100%;
        position: absolute;
        inset: 0 0 0 0;
        z-index: -1;
        opacity: 0;

        &:focus {
            border-radius: 10px;

            & + #{$b}__switch {
                border-color: $sherpa-blue;
            }
        }
    }

    &__label {
        display: flex;
        flex: 1;
        font-weight: bold;
        color: $gray;
    }

    &__switch {
        display: flex;
        position: relative;
        border: 1px solid $gray-lighter;
        margin-left: 5px;
        background: white;
        border-radius: 30px;
        width: 38px;
        height: 21px;

        &::after {
            content: '';
            position: absolute;
            top: 3px;
            left: 0;
            width: 13px;
            height: 13px;
            margin: 0 4px;
            border-radius: 100px;
            background-color: $gray-lighter;
            transition: color 0.2s ease, transform 0.2s ease;
        }
    }
}
</style>
